import { useMemo, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectOrdersListingResults, FETCH_ORDERS, FETCH_MORE_ORDERS } from '../../stores/order'

export function useOrdersListing() {
  const dispatch = useDispatch()
  const listing = useSelector(selectOrdersListingResults)

  const handlers = useMemo(
    () => ({
      onLoadMore: () => dispatch(FETCH_MORE_ORDERS.request()),
    }),
    [dispatch],
  )

  const onLoadInitial = useCallback(() => {
    dispatch(FETCH_ORDERS.request())
  }, [dispatch])

  // automatically call load initial
  // the extra pages will be lost but data will be fresh
  useEffect(() => {
    onLoadInitial()
  }, [onLoadInitial])

  return {
    ...listing,
    ...handlers,
    onLoadInitial,
  }
}
